import { render } from "./PropertiesModal.vue?vue&type=template&id=09522f4a&scoped=true&ts=true"
import script from "./PropertiesModal.vue?vue&type=script&lang=ts"
export * from "./PropertiesModal.vue?vue&type=script&lang=ts"

import "./PropertiesModal.vue?vue&type=style&index=0&id=09522f4a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09522f4a"]])

export default __exports__